module.exports = __webpack_public_path__ + "static/img/costList.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costList.png
// module id = 528
// module chunks = 0